var map = {
	"./australiaPromo.vue": [
		"a86a",
		"chunk-3ffefbee",
		"chunk-30890e48",
		"chunk-2b945bf3"
	],
	"./katsubetPromo.vue": [
		"17ff",
		"chunk-3ffefbee",
		"chunk-317b6c20"
	],
	"./modern2Promo.vue": [
		"3545",
		"chunk-3ffefbee",
		"chunk-0a4a3676"
	],
	"./modernPromo.vue": [
		"3aa0",
		"chunk-3ffefbee",
		"chunk-30890e48",
		"chunk-2a4fdab8"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "12c3";
module.exports = webpackAsyncContext;